module.exports = __webpack_public_path__ + "static/ml-f82cd9a94c2966acacf7d40695eab532.svg";